<template>
  <v-dialog width="350px" persistent v-model="editDialog" class="editDialogsRow">
    <v-card-text class="pa-0" slot="activator">
      Add Coordinator
      <v-icon class="text-xs-right">add</v-icon>
    </v-card-text>
    <v-card>
      <v-container>
        <v-layout justify-end row wrap>
          <v-flex xs1 class="mb-2">
            <v-icon depressed class="cyan--text text--lighten-1" @click="editDialog = false">close</v-icon>
          </v-flex>
          <v-flex xs12 class="mb-2">
            <v-card-title class="text-xs-center justify-center"><h2>Edit {{ trial.trialName }} Coordinators</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedCoordinators" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-card-text>
              <h3>Current Coordinators:</h3>
              <div v-for="item in coordinatorsGetter" v-bind:key="item.coordinatorID">
                {{ item.coordinatorName }}
              </div>
            <!--<v-select
              :items="editedCoordinators"
              v-model="holder"
              item-value="name"
              label="Coordinator"
              multiple-line
              bottom
              multiple
            ></v-select> -->
            <v-select
                name="trial.trialCoordinators"
                label="Add Trial Coordinators"
                :items="coordinators"
                item-value="coordinatorId"
                item-text="coordinatorName"
                v-model="editedCoordinators"
                id="trial.trialCoordinators"
                multiple
                max-height="400"
                hint="Pick your coordinators"
                persistent-hint
              ></v-select>             
            </v-card-text>
            <v-btn depressed class="grey white--text" to="/coordinator/new">Create New Coordinator</v-btn>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text cyan " @click="onSaveChanges">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['trial'],
  data () {
    return {
      editDialog: false,
      editedCoordinators: this.trial.trialCoordinators,
      trialCoordinators: [],
      holder: []
    }
  },
  computed: {
    coordinators () {
      return this.$store.getters.loadedCoordinators
    },
    loadCoordinators () {
      return this.$store.getters.loadedTrials
    },
    coordinatorsGetter () {
      if (this.trial.trialCoordinators) {
        var indis = []
        var val = []
        // var item = []
        this.trial.trialCoordinators.filter(function (elem) {
          indis.push(elem)
        })
        console.log('Coordinator IDs: ' + JSON.stringify(indis))
        for (let i = 0; i < indis.length; i++) {
          console.log('SECOND GET Coordinator: ' + JSON.stringify(this.$store.getters.loadedCoordinator(indis[i])))
          if (this.$store.getters.loadedCoordinator(indis[i])) {
            val.push(this.$store.getters.loadedCoordinator(indis[i]))
          }
        }
        console.log('FINAL val: ' + JSON.stringify(val))
        return val
      } else {
        return null
      }
    }
  },
  methods: {
    onSaveChanges () {
      this.trialCoordinators = this.editedCoordinators
      this.editDialog = false
      console.log('edit page: ' + this.trialCoordinators)
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialCoordinators: this.trialCoordinators
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditTrialCoordinatorsDialog.vue?3eb30c52